// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QLbO","delete":"styles_delete__-GS-p","update":"styles_update__3RvJC","add":"styles_add__Gvu8y"};